export default {
	isLoggingEnabled: Boolean(import.meta.env.VITE_APP_LOG),
	isDev: import.meta.env.DEV,
	storageUrl: import.meta.env.VITE_APP_STORAGE_URL,
}
